import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18next from 'i18next'
import { getLanguage, getLocaleResourcePath, languageSwitchItem } from '../actions/locales'
import { getURLs, getVersion, connectionStatus, featuresStatus } from '../actions/api'
import { setURLs, setVersion, setFeatures, setConfig } from '../actions/localStates'
import Header from '../components/header/Header';
import { init } from '../actions/stringEncodersFuncs'
import Body from '../components/body/Body'
import RoutedBody from '../components/body/RoutedBody'
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import '../css/sjwsa-client-0.1.css'

class App extends Component {

	componentDidMount() {
		let _this = this

		this.checkConnection = () => {
			_this.props.actions.connectionStatus(_this.props.baseUrls.psDSUrl)
			
			_this.props.actions.featuresStatus(_this.props.baseUrls.psDSUrl)
			.then((response) => {
				console.log(response)
				this.props.actions.setFeatures(response)
			});

			setTimeout(this.checkConnection, 3000);
		}
		i18next.changeLanguage('uk');

		this.props.actions.getURLs()
		.then((response) => {
			_this.props.actions.setURLs(response)
			_this.props.actions.setConfig(response)
			_this.checkConnection();

		})

		this.props.actions.getVersion()
		.then((response) => {
			_this.props.actions.setVersion(response)
		})

		this.props.actions.init()
	}

	render() {
		return (
			<div className="container" style={{minWidth: "1000px"}}>
				{
					this.props.baseUrls.version
					? <div>
						<div>
							{
								this.props.baseUrls.useRoutes
								? <RoutedBody />
								: <div>
									<Header connectionStatus={this.props.connectionStatus} />
									{
										this.props.connectionStatus.status
										? <Body />
										: null
									}
								</div>
							}
						</div>
						<div className="col-12 text-right" style={{position: "fixed", bottom: "0px", right: "0px", fontSize: "12px", paddingRight: "10px", paddingTop: "25px", color: "#ebebeb"}}>
						    <label>{i18next.t("version" : "version")} {this.props.baseUrls.version} build {this.props.baseUrls.build}</label>
						</div>
					</div>
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        connectionStatus: state.connectionStatusReucer,
        locales: state.i18n,
        localesReducer: state.localesReducer,
        baseUrls: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    getLanguage,
	    getLocaleResourcePath,
	    languageSwitchItem,
	    init,
	    getURLs,
		getVersion,
		setURLs,
		setConfig,
		setVersion,
		connectionStatus,
		featuresStatus,
		setFeatures
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/containers/App.js